export const A2_FORM = 'a2_form';
export const AUTH_LETTER = 'auth_letter';
